"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactTextMask = _interopRequireDefault(require("react-text-mask"));

var _createNumberMask = _interopRequireDefault(require("text-mask-addons/dist/createNumberMask"));

var _ = require("../..");

var _bind = _interopRequireDefault(require("classnames/bind"));

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./TextField.css");

var _styles = {
  "text-field": "TextField__text-field___1f4iY",
  "small": "TextField__small___2DRmP",
  "disabled": "TextField__disabled___3yOV1",
  "label": "TextField__label___3bRn1",
  "error": "TextField__error___17mSw",
  "mask-currency": "TextField__mask-currency___13o93",
  "helper-text": "TextField__helper-text___1jWOs",
  "input-container": "TextField__input-container___32VvW",
  "currency-format": "TextField__currency-format___2b4sv",
  "input-trailing-icon": "TextField__input-trailing-icon___28IkH",
  "trailing-icon": "TextField__trailing-icon___2X8U6",
  "trailing-content": "TextField__trailing-content___wkSmH"
};

const styles = _bind.default.bind(_styles);

const TextField = (0, _mobxReact.observer)(({
  className,
  inputClassName,
  labelClassName,
  name,
  label,
  value,
  disableBrowserAutofill,
  currencyFormat,
  dateFormat,
  einNumberFormat,
  numericFormat,
  percentFormat,
  socialSecurityFormat,
  phoneNumber,
  yearFormat,
  disabled,
  error,
  placeholder,
  rows,
  multiline,
  required,
  small,
  autoFocus,
  helperText,
  type = 'text',
  onChange,
  onBlur,
  onKeyDown,
  dataTestId,
  secondaryLabel,
  secondaryLabelTheme,
  trailingIcon,
  trailingContent
}) => {
  const composed_label_classname = (0, _bind.default)(styles('label'), labelClassName);
  const composed_classname = (0, _bind.default)(styles('input-container', {
    'currency-format': currencyFormat,
    'input-trailing-icon': !!trailingIcon || !!trailingContent
  }), className);
  const currencyMaskOptions = {
    prefix: '',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: ',',
    allowDecimal: true,
    decimalSymbol: '.',
    decimalLimit: 2,
    allowNegative: false,
    allowLeadingZeroes: true
  };
  const yearMaskOptions = {
    prefix: '',
    suffix: '',
    includeThousandsSeparator: false,
    thousandsSeparatorSymbol: '',
    allowDecimal: false,
    decimalSymbol: '',
    decimalLimit: 0,
    integerLimit: 4,
    allowNegative: false,
    allowLeadingZeroes: false
  };
  const percentMaskOptions = {
    prefix: '',
    suffix: ' %',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: ',',
    allowDecimal: true,
    decimalSymbol: '.',
    decimalLimit: 2,
    allowNegative: false,
    allowLeadingZeroes: true,
    integerLimit: 4
  };
  const numericMaskOption = {
    prefix: '',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: ',',
    allowDecimal: true,
    decimalSymbol: '.',
    allowLeadingZeroes: true
  };
  const numericMask = (0, _createNumberMask.default)(numericMaskOption);
  const currencyMask = (0, _createNumberMask.default)(currencyMaskOptions);
  const percentMask = (0, _createNumberMask.default)(percentMaskOptions);
  const yearMask = (0, _createNumberMask.default)(yearMaskOptions);
  const phoneNumberMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  const dateMask = [/[0-9]/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  const socialSecurityMask = [/[0-9]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  const einNumberFormatMask = [/[0-9]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

  const getCurrentMask = () => {
    if (percentFormat) return percentMask;
    if (yearFormat) return yearMask;
    if (currencyFormat) return currencyMask;
    if (phoneNumber) return phoneNumberMask;
    if (dateFormat) return dateMask;
    if (socialSecurityFormat) return socialSecurityMask;
    if (einNumberFormat) return einNumberFormatMask;
    return numericMask;
  };

  const getIconName = type => {
    switch (type) {
      case 'success':
        return _.IconEnum.check_circle;

      case 'failed':
        return _.IconEnum.exclamation_circle;

      case 'warning':
        return _.IconEnum.exclamation_triangle;

      default:
        return _.IconEnum.info_circle;
    }
  };

  const getIconColor = type => {
    switch (type) {
      case 'success':
        return _.Color.semantic.$success50;

      case 'failed':
        return _.Color.semantic.$error50;

      case 'warning':
        return _.Color.semantic.$warning50;

      default:
        return _.Color.neutral._90;
    }
  };

  return _react.default.createElement("div", {
    className: (0, _bind.default)(styles('text-field', {
      disabled,
      error,
      small
    }))
  }, _react.default.createElement(_.Content, {
    flex: true,
    justifyContent: 'space-between'
  }, label && _react.default.createElement("label", {
    className: composed_label_classname,
    htmlFor: name
  }, label), secondaryLabel && _react.default.createElement(_.Content, {
    flex: true,
    gap: 8
  }, secondaryLabelTheme && _react.default.createElement(_.Icon, {
    name: getIconName(secondaryLabelTheme),
    color: getIconColor(secondaryLabelTheme)
  }), _react.default.createElement(_.Text, {
    status: secondaryLabelTheme
  }, secondaryLabel))), multiline || rows ? _react.default.createElement("span", {
    className: composed_classname
  }, _react.default.createElement("textarea", {
    id: name,
    name: disableBrowserAutofill ? new Date().toUTCString() : name,
    placeholder: placeholder,
    className: composed_classname,
    autoFocus: autoFocus,
    rows: Number(rows),
    value: value || '',
    onChange: e => onChange && onChange(e),
    onBlur: e => onBlur && onBlur(e),
    disabled: disabled,
    "aria-labelledby": name,
    "aria-label": label && label,
    "data-testid": dataTestId
  })) : _react.default.createElement("span", {
    className: composed_classname
  }, currencyFormat && _react.default.createElement("span", {
    className: (0, _bind.default)(styles('mask-currency'))
  }, "$"), currencyFormat || numericFormat || yearFormat || phoneNumber || percentFormat || dateFormat || socialSecurityFormat || einNumberFormat ? _react.default.createElement(_reactTextMask.default, {
    id: name,
    className: inputClassName,
    name: disableBrowserAutofill ? new Date().toUTCString() : name,
    mask: getCurrentMask(),
    placeholder: currencyFormat ? '' : placeholder,
    value: value !== null && value !== void 0 ? value : '',
    onChange: e => onChange && onChange(e),
    onBlur: e => onBlur && onBlur(e),
    autoFocus: autoFocus,
    disabled: disabled,
    "aria-labelledby": name,
    "aria-label": label && label,
    "data-testid": dataTestId,
    autoComplete: 'chrome-off'
  }) : _react.default.createElement("input", {
    id: name,
    className: inputClassName,
    name: disableBrowserAutofill ? new Date().toUTCString() : name,
    autoComplete: 'chrome-off',
    type: currencyFormat ? 'text' : type,
    disabled: disabled,
    placeholder: currencyFormat ? '' : placeholder,
    required: required,
    value: value || '',
    autoFocus: autoFocus,
    min: type === 'number' ? 0 : '',
    onChange: e => onChange && onChange(e),
    onBlur: e => onBlur && onBlur(e),
    onKeyDown: onKeyDown,
    "aria-labelledby": name,
    "aria-label": label && label,
    "data-testid": dataTestId
  }), trailingIcon && _react.default.createElement("div", {
    className: styles('trailing-icon')
  }, _react.default.createElement(_.Icon, {
    name: trailingIcon
  })), trailingContent && _react.default.createElement("div", {
    className: styles('trailing-content')
  }, trailingContent)), typeof helperText === 'string' ? _react.default.createElement(_.Text, {
    tag: 'p',
    variant: 'regular',
    className: (0, _bind.default)(styles('helper-text'))
  }, helperText) : helperText ? helperText : _react.default.createElement(_react.default.Fragment, null));
});
var _default = TextField;
exports.default = _default;